import { Reveal, ChapterLabel } from "@/components/site/Reveal";
import { FEEDING, RELEASE } from "@/lib/content";
import { Check, X, Sprout } from "lucide-react";

export default function FuetterungAuswilderung() {
  return (
    <section
      id="fuetterung"
      data-testid="section-fuetterung"
      className="relative py-20 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <ChapterLabel index={2} label="Fütterung & Auswilderung" color="text-brand-orange" />
        <Reveal className="mt-6 max-w-3xl">
          <h2 className="font-heading font-bold text-ink text-3xl md:text-4xl lg:text-5xl tracking-tight">
            Richtig füttern, sanft auswildern
          </h2>
          <p className="mt-4 text-lg md:text-xl leading-relaxed text-ink-muted">
            Damit aus einem kleinen Findling wieder ein starker Wildling wird –
            hier das Wichtigste zum Futter und zur Rückkehr in die Natur.
          </p>
        </Reveal>

        {/* Fütterung: Do & Don't */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-8">
          {FEEDING.map((block, idx) => {
            const good = idx === 0;
            return (
              <Reveal
                key={block.title}
                delay={idx * 0.1}
                data-testid={`feeding-block-${idx + 1}`}
                className={`rounded-[2rem] p-8 md:p-10 shadow-soft border ${
                  good
                    ? "bg-brand-green/8 border-brand-green/20"
                    : "bg-brand-pink/8 border-brand-pink/20"
                }`}
              >
                <h3 className="font-heading font-bold text-xl md:text-2xl text-ink">
                  {block.title}
                </h3>
                <ul className="mt-6 space-y-4">
                  {block.points.map((p) => (
                    <li key={p} className="flex items-start gap-3">
                      <span
                        className={`mt-0.5 shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-white ${
                          good ? "bg-brand-green" : "bg-brand-pink"
                        }`}
                      >
                        {good ? <Check className="w-4 h-4" /> : <X className="w-4 h-4" />}
                      </span>
                      <span className="text-base md:text-lg text-ink leading-snug">{p}</span>
                    </li>
                  ))}
                </ul>
              </Reveal>
            );
          })}
        </div>

        {/* Auswilderung */}
        <Reveal className="mt-16 flex items-center gap-3">
          <Sprout className="w-7 h-7 text-brand-green" />
          <h3 className="font-heading font-bold text-2xl md:text-3xl text-ink">
            Zurück in die Freiheit
          </h3>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-8">
          {RELEASE.map((item, i) => (
            <Reveal
              key={item.title}
              delay={i * 0.08}
              data-testid={`release-step-${i + 1}`}
              className="rounded-[2rem] bg-white p-8 shadow-soft border border-ink/5"
            >
              <span className="font-accent text-3xl text-brand-orange">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h4 className="mt-2 font-heading font-bold text-xl text-ink">
                {item.title}
              </h4>
              <p className="mt-3 text-base md:text-lg leading-relaxed text-ink-muted">
                {item.text}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
